/* eslint-disable */
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { securedAxiosInstance } from '../../api/axios';
import { saveLog, getVaults } from '../../stores/slices/vaults/vaultsActions';
import { Select as Multiselect } from 'chakra-react-select';

const VaultModal = ({ isOpen, onOpen, onClose, toUpdate }) => {
  const { userInfo } = useSelector(state => state.user);
  const schema = yup
    .object({
      logDetail: yup.string().required('Log detail is required'),
    })
    .required();

  const dispatch = useDispatch();
  const toast = useToast();

  const [users, setUsers] = useState([]);
  useEffect(() => {
    const getUsers = async () => {
      const res = await securedAxiosInstance.get(`/users`);
      setUsers(
        res.data.map(data => {
          return {
            label: data.email,
            full_name: data.full_name,
            value: data.id,
          };
        })
      );
      return;
    };

    getUsers();
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });
  useEffect(() => {
    if (toUpdate.state) {
      reset({
        userSelect: users.filter(
          option => option.full_name === toUpdate.vault.name
        )[0],
      });
    }
  }, [users, toUpdate]);

  const onSave = async data => {
    const res = await dispatch(
      saveLog({
        refId: data.userSelect ? data.userSelect.value : null,
        logDetail: data.logDetail,
        userId: userInfo.id,
        type: 'employee',
        isUpdate: toUpdate,
      })
    );

    if (res.type === 'vault/saveLog/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      reset();
      onClose();
      dispatch(getVaults());
      toast({
        description: toUpdate.state
          ? 'Log has been updated'
          : 'Log has been created',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => {
        reset();
        onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit(onSave)}>
          <ModalHeader>{toUpdate.state ? 'Edit' : 'Add new'} log</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={'2'}>
              <Controller
                control={control}
                name="userSelect"
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <FormControl isInvalid={!!error} id="userSelect">
                    <FormLabel>Employee</FormLabel>
                    <Multiselect
                      // isMulti
                      name={name}
                      ref={ref}
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      options={users}
                      placeholder="Select one"
                      isClearable
                      closeMenuOnSelect
                      className="chakra-react-select"
                      classNamePrefix="chakra-react-select"
                      selectedOptionStyle="check"
                      chakraStyles={{
                        dropdownIndicator: provided => ({
                          ...provided,
                          bg: 'transparent',
                          px: 2,
                          cursor: 'inherit',
                        }),
                        indicatorSeparator: provided => ({
                          ...provided,
                          display: 'none',
                        }),
                      }}
                    />

                    <FormErrorMessage>
                      {error && error.message}
                    </FormErrorMessage>
                  </FormControl>
                )}
              />
              <FormControl id="logDetail" isInvalid={errors.logDetail}>
                <FormLabel>Log detail</FormLabel>
                <Textarea
                  id="logDetail"
                  {...register('logDetail')}
                  defaultValue={toUpdate.state ? toUpdate.vault.note : ''}
                />
                <FormErrorMessage>
                  {errors.logDetail && errors.logDetail.message}
                </FormErrorMessage>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} type="submit" isLoading={isSubmitting}>
              Save
            </Button>
            <Button
              onClick={() => {
                reset();
                onClose();
              }}
              variant="outline"
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default VaultModal;
